<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Claim Type Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="items" slot-scope="props">
            <td>{{ appDesc(props.item.appId) }}</td>
            <td>{{ props.item.clmType }}</td>
            <td>{{ props.item.seqNo }}</td>
            <td>{{ props.item.clmTypeDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['claimReview'])" @review="doReview(props.item)" remove @remove="doPromptRemove(props.item)"
                query @query="doQuery(props.item)" />
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Claim Type
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="showClmTypeDialog" width="800px" v-if="checkAccess(['claimReview'])" persistent>
        <clm-type-dialog :selectedClmType="selectedClmType" :mode="mode" @close="showClmTypeDialog = false" @fetchData="fetchData" />
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove" title="Claim Type">
        Are you sure that you want to remove the selected claim type? (<b>{{deleteClmType.clmType}} - {{deleteClmType.clmTypeDesc}}</b>)
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import { appIDDesc } from '@/const/underwriting'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ClmTypeDialog from './ClmTypeDialog'
export default {
  data() {
    return {
      loading: false,
      search: '',
      headers: [
        { text: 'Module', align: 'left', value: 'appId' },
        { text: 'Claim Type', align: 'left', value: 'clmType' },
        { text: 'Seq No', align: 'left', value: 'seqNo' },
        { text: 'Claim Type Description', align: 'left', value: 'clmTypeDesc' },
        TableConst.tableActionHeader
      ],
      mode: '',
      selectedClmType: {
        appId: '',
        clmType: '',
        seqNo: '',
        clmTypeDesc: '',
        permMultiClmt: false
      },
      deleteClmType: {},
      showClmTypeDialog: false,
      promptRemove: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmTypes
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = data
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to retrieve claim types (Missing API URL)')
      }
      this.loading = false
    },
    doNew() {
      this.selectedClmType.appId = ''
      this.selectedClmType.clmType = ''
      this.selectedClmType.clmTypeDesc = ''
      this.selectedClmType.seqNo = ''
      this.selectedClmType.permMultiClmt = false
      this.mode = 'new'
      this.showClmTypeDialog = true
    },
    doReview(clmType) {
      this.selectedClmType.appId = clmType.appId
      this.selectedClmType.clmType = clmType.clmType
      this.selectedClmType.clmTypeDesc = clmType.clmTypeDesc
      this.selectedClmType.seqNo = clmType.seqNo
      this.selectedClmType.permMultiClmt = clmType.permMultiClmt
      this.mode = 'review'
      this.showClmTypeDialog = true
    },
    doQuery(clmType) {
      this.selectedClmType.appId = clmType.appId
      this.selectedClmType.clmType = clmType.clmType
      this.selectedClmType.clmTypeDesc = clmType.clmTypeDesc
      this.selectedClmType.seqNo = clmType.seqNo
      this.selectedClmType.permMultiClmt = clmType.permMultiClmt
      this.mode = 'query'
      this.showClmTypeDialog = true
    },
    doPromptRemove(clmType) {
      this.deleteClmType = clmType
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmType
      if (apiURI) {
        this.loading = true
        const expand = {
          appId: this.deleteClmType.appId,
          clmType: this.deleteClmType.clmType
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Unable to remove claim type (Missing API URL)')
      }
    },
    appDesc(appID) {
      return appIDDesc[appID]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  components: {
    ClmTypeDialog: ClmTypeDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
